import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const getProperties = async (featured = null) => {
  try {
    const params = featured !== null ? { featured } : {};
    const response = await axios.get(`${API}/properties`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching properties:', error);
    throw error;
  }
};

export const getPropertyById = async (id) => {
  try {
    const response = await axios.get(`${API}/properties/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching property:', error);
    throw error;
  }
};

export const createProperty = async (propertyData) => {
  try {
    const response = await axios.post(`${API}/properties`, propertyData);
    return response.data;
  } catch (error) {
    console.error('Error creating property:', error);
    throw error;
  }
};

export const updateProperty = async (id, propertyData) => {
  try {
    const response = await axios.put(`${API}/properties/${id}`, propertyData);
    return response.data;
  } catch (error) {
    console.error('Error updating property:', error);
    throw error;
  }
};

export const deleteProperty = async (id) => {
  try {
    const response = await axios.delete(`${API}/properties/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting property:', error);
    throw error;
  }
};

export const submitEnquiry = async (enquiryData) => {
  try {
    const response = await axios.post(`${API}/enquiries`, enquiryData);
    return response.data;
  } catch (error) {
    console.error('Error submitting enquiry:', error);
    throw error;
  }
};

export const getEnquiries = async () => {
  try {
    const response = await axios.get(`${API}/enquiries`);
    return response.data;
  } catch (error) {
    console.error('Error fetching enquiries:', error);
    throw error;
  }
};

// Bidding API functions
export const submitBid = async (bidData) => {
  try {
    const response = await axios.post(`${API}/bids`, bidData);
    return response.data;
  } catch (error) {
    console.error('Error submitting bid:', error);
    throw error;
  }
};

export const getBids = async (propertyId = null) => {
  try {
    const params = propertyId ? { property_id: propertyId } : {};
    const response = await axios.get(`${API}/bids`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching bids:', error);
    throw error;
  }
};

export const getBidById = async (bidId) => {
  try {
    const response = await axios.get(`${API}/bids/${bidId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching bid:', error);
    throw error;
  }
};

export const updateBidStatus = async (bidId, status) => {
  try {
    const response = await axios.patch(`${API}/bids/${bidId}/status?status=${status}`);
    return response.data;
  } catch (error) {
    console.error('Error updating bid status:', error);
    throw error;
  }
};